<template>
  <section>
    <div v-if="propMensalista"
         class="receber-todos">
      <input v-if="propMensalista"
             id="selecionarTodos"
             class="mr-2"
             type="checkbox"
             @change="selecionarTodos()">
      <label for="selecionarTodos">Selecionar todos os itens</label>
    </div>
    <div class="row table-header">
      <span v-if="propMensalista"
            class="ml-2 mr-3" />
      <span class="col-2">OS/Pedido</span>
      <span class="col-1">Tipo</span>
      <span class="col-1 mr-3">Data</span>
      <span class="col-2">Solicitante</span>
      <span :class="!propMensalista ? 'col-2' : 'col-1'">Selo</span>
      <span class="col-2">Valor</span>
      <span v-if="propMensalista"
            class="col-1">Status</span>
      <span class="col" />
    </div>

    <div v-for="item in listaPedidos"
         :key="item.cx_pedido_id">
      <div class="row table-linha align-items-center">
        <input v-if="propMensalista && item.status_pg === 'faturado'"
               class="ml-2 mr-1"
               :checked="selecionarTodosPedidos"
               :disabled="selecionarTodosPedidos"
               type="checkbox"
               @change="addItem(item)">
        <span v-if="propMensalista && item.status_pg != 'faturado'"
              class="ml-2 mr-3" />
        <span class="col-2 table-linha-item"
              @click="showInfos(item)">
          {{ item.ordemServico ?
            item.ordemServico.numero : 
            item.lancamentosAvulso ?
              item.lancamentosAvulso.cx_lancamento_id :'' }}
        </span>
        <span class="col-1"
              @click="showInfos(item)">
          {{ item.tipo_pedido }}
        </span>
        <span class="col-1 mr-3 table-linha-item"
              @click="showInfos(item)">
          {{ item.data_lancamento | date }}
        </span>
        <span class="col-2 table-linha-item"
              @click="showInfos(item)">
          {{ item.solicitante.length >=20 ?
            item.solicitante.substring(0, 20) +'...' : item.solicitante }}
        </span>
        <TableSelo v-if="item.ordemServico"
                   :class="!propMensalista ? 'col-2' : 'col-1'"
                   :prop-selo="item.ordemServico.itens[0] ?
                     item.ordemServico.itens[0].seloItemOs[0] : null"
                   @click="showInfos(item)" />
        <span v-else
              :id="item.cx_pedido_id"
              :class="!propMensalista ? 'col-2' : 'col-1'"
              @click="showInfos(item)">
          ---
        </span>
        <input v-money="money"
               :value="item.ordemServico ? item.ordemServico.valor_total :
                 item.lancamentosAvulso ? item.lancamentosAvulso.valor_total: ''"
               disabled
               class="col-2"
               @click="showInfos(item)">
        <span v-if="propMensalista"
              class="col-1">{{ item.status_pg[0].toUpperCase() + item.status_pg.substring(1) }}</span>
        <span class="col">
          <Pagamento v-show="item.status_pg !== 'concluido'"
                     :prop-ordens-servico="item"
                     @atualizarTabela="atualizarTabela" />
          <DetalhesPagamento v-show="item.status_pg === 'concluido'"
                             :prop-pedidos="item"
                             @atualizarTabela="atualizarTabela" />
        </span>
        <article v-if="item.check_pendentes === true"
                 class="col table-infos">
          <ItemTableLancamento :prop-lancamento="item.lancamentosAvulso" />
          <ItemTableOs :prop-os="item.ordemServico"
                       :prop-valor-total="item.valor" />
        </article>
      </div>
    </div>
    <FiltroPendentes v-if="propPedidosFc" />
  </section>
</template>

<script>

  //Importes
  import { VMoney } from 'v-money'

  // Components
  import Pagamento from './Pagamento.vue'
  import ItemTableLancamento from './ItemTableLancamento.vue'
  import ItemTableOs from './ItemTableOs.vue'
  import TableSelo from './TableSelo.vue'
  import FiltroPendentes from '../Filtros/FiltroPendentes.vue'
  import DetalhesPagamento from '../Mensalistas/PagamentosFatutados/DetalhesPagamento/DetalhesPagamento.vue'

  // Services
  import pedidoService from '../pedidoService'
  import MensalistaService from '../Mensalistas/mensalistaService'

  export default ({
    name: 'TablePendentes',
    directives: {
      money: VMoney
    },
    components: {
      Pagamento,
      ItemTableLancamento,
      ItemTableOs,
      TableSelo,
      FiltroPendentes,
      DetalhesPagamento
    },
    props: {
      // Verifica se o componente está sendo chamado em mensalista
      propMensalista: {type: Array, default: null},
      propPedidosFc: {type: Array, default: null},
      propFiltroMensalista: {type: Object, default: null}
    },
    data () {
      return {
        listaPedidos: [],
        listaPagamento: [],
        selecionarTodosPedidos: false,
        // Utilizamos nos campos de valores
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
      }
    },
    computed: {
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
    },
    watch: {
      propPedidosFc () {
        if (this.propPedidosFc) this.listaPedidos = this.propPedidosFc
      },
      propMensalista () {
        if (this.propMensalista) this.listaPedidos = this.atualizarTabela()
      }
    },
    methods: {
      showInfos (item) {   
        item.check_pendentes = !item.check_pendentes
      },
      addItem (item) {
        const itemExistente = this.listaPagamento.find((pedido) => pedido.cx_pedido_id === item.cx_pedido_id)
        if (!itemExistente) {
          this.listaPagamento.push(item) 
        } else {     
          this.listaPagamento.forEach((pedido, index) => {
            if (pedido.cx_pedido_id === itemExistente.cx_pedido_id) this.listaPagamento.splice(index, 1)
          })
        }
        this.$emit('listaPagamento', this.listaPagamento)
      },
      selecionarTodos () {
        this.selecionarTodosPedidos = !this.selecionarTodosPedidos
        if (!this.selecionarTodosPedidos) {
          this.listaPagamento = []
          return this.$emit('listaPagamento', this.listaPagamento)
        }
        this.listaPagamento = this.listaPedidos.filter(pedido => pedido.status_pg === 'faturado')
        this.$emit('listaPagamento', this.listaPagamento)
      },
      async atualizarTabela () {
        // O componente é chamado tanto na Frente de Caixa como nos Pagamentos Faturados Mensalistas
        // Verificamos onde ele está sendo chamado e atualizamos a lista de acordo o contexto
        try {
          loader({text: 'Atualizando', active: true})
          if (this.propPedidosFc) {
            await this.atualizaPedidosCx()
          }
          if (this.propMensalista) {
            const mensalistaPedidos = await MensalistaService.buscarById(this.propFiltroMensalista)
            mensalistaPedidos[0].pedidos.forEach(item => {
              item.check_pendentes = false
              item.valorTotal = item.ordemServico ? item.ordemServico.valor_total :
                item.lancamentosAvulso ? item.lancamentosAvulso.valor_total : ''
            })
            this.listaPedidos = mensalistaPedidos[0].pedidos
            this.listaPagamento = []
            this.selecionarTodosPedidos = false
            this.$emit('listaPagamento', this.listaPagamento)
          }
        } catch (err) {
          console.log('TablePendentes', err)
        } finally {
          loader({text: null, active: false})
        }
      },
      async atualizaPedidosCx () {
        this.$store.dispatch('frenteCaixa/atualizarPedidos')
      },
    }
  })

</script>

<style scope>
section {
  margin-top: 10px ;

  padding: 0;
  color: black;
}
input:disabled {
    color: black;
    box-shadow: 0 0 0 0;
    border: 0 none;
    outline: 0;
    background: transparent;
}
.receber-todos {
  margin-left: -10px;
  margin-top: 30px;
}
.table-header {
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  background-color: #00C0A7;
  font-size: 18px;
  border: solid 1px #00C0A7;
}
.table-linha {
  padding-top: 5px;
  padding-bottom: 5px;
  border: solid 1px #cacbcb;
  transition: .3s;
  font-size: 14px;
}
.table-linha:hover {
  background-color: #f6f6f6;
  cursor: pointer;
  transition: .3s;
}
.table-infos {
  margin-top: 10px;
  border-top: solid 1px #cacbcb;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.table-infos-title {
  font-weight: bold;
}

</style>